import { render, staticRenderFns } from "./NotForm.vue?vue&type=template&id=0979a8fc"
import script from "./NotForm.vue?vue&type=script&lang=ts"
export * from "./NotForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports